import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { Input } from '@shared/ui-components';


export const MaterialInputField: React.SFC<any> = (
  props: WrappedFieldProps & any,
): JSX.Element => {
  const {
    input,
    disabled,
    meta: { submitFailed, error },
    ...rest } = props;

  const onChange = (_event: React.ChangeEvent<{}>, value: string): void => {
    input.onChange(value);
  };

  const inputProps = { ...input, disabled };
  return (
    <Input
      {...input}
      error={submitFailed && error}
      onChange={onChange} // eslint-disable-line react/jsx-no-bind
      input={inputProps}
      {...rest}
    />
  );
};
